import { render, staticRenderFns } from "./BackFailReason.vue?vue&type=template&id=2dad376a&scoped=true&"
import script from "./BackFailReason.vue?vue&type=script&lang=js&"
export * from "./BackFailReason.vue?vue&type=script&lang=js&"
import style0 from "./BackFailReason.vue?vue&type=style&index=0&id=2dad376a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad376a",
  null
  
)

export default component.exports